module.exports = require("lodash/defaults");


//////////////////
// WEBPACK FOOTER
// external "lodash/defaults"
// module id = 18
// module chunks = 0